<template>
  <div class="Buy">
    <div class="page-title">{{ title }}</div>
    <div>
      <ATable
        ref="table"
        v-loading="loading"
        max-height="810px"
        :data="items"
        :placeholder="placeholder"
        :search_field="search_field"
        hide-button-insert
        hide-pagination
        border
      >
        <div slot="search">
          <div class="inline">
            <APeriodSelector 
              ref="period" 
              value="1w"
              @change="handleChangePeriod" 
            />
          </div>
          <div class="inline">
            <el-button
              type="primary"
              size="mini"
              round
              v-shortkey="['f5']"
              @shortkey.native="handleClickSearch"
              @click="handleClickSearch"
            >검색(F5)</el-button>
          </div>
        </div>
        <el-table-column
          type="index"
          label="No"          
          :index="handleIndex"
        />
        <el-table-column
          prop="code"
          label="발주번호"          
          width="100"
        />
        <el-table-column
          prop="customer_name"
          label="거래처"  
          width="150"                  
          show-overflow-tooltip
        />
        <el-table-column
          prop="product_name"
          label="품목명"                    
          show-overflow-tooltip
        />
        <el-table-column
          prop="size"
          :label="$t('lang.size')"          
          :width="$width.size"
          show-overflow-tooltip
        />        
        <el-table-column 
          prop="amount" 
          label="입고량" 
          class-name="cell-number"
          width="60"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="unit_name"
          label="단위"                    
          :width="$width.unit_name"
        />
        <el-table-column
          prop="cost"
          label="단가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="supply_price"
          label="공급가"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="tax"
          label="세액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />
        <el-table-column
          prop="price"
          label="금액"
          class-name="cell-number"
          :width="$width.price"
          :formatter="util.numberFormat"
        />        
        <el-table-column
          prop="created_user_name"
          :label="$t('lang.created_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="modified_user_name"
          :label="$t('lang.modified_user_name')"
          :width="$width.username"
        />
        <el-table-column
          prop="created_at"
          :label="$t('lang.created_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
        <el-table-column
          prop="modified_at"
          :label="$t('lang.modified_at')"
          :width="$width.date"
          :formatter="util.dateFormat"
        />
      </ATable>
    </div>
    
  </div>
</template>
<script>

export default {
  name: "Buy",
  data() {
    return {
      title: this.$t("title.order_stat"),
      period: {},
      placeholder: "발주번호, 거래처, 품목명",
      search_field: ["code", "customer_name", "product_name"],
      loading: false,
      items: [],
    };
  },  
  mounted() {
    this.$nextTick(() => this.loadData());
  },
  methods: {
    loadData() {
      this.loading = true;
      this.api.listInbound(this.period).then(res => {
        this.loading = false;
        if (res.error !== this.system.noError) {
          this.util.notify_response_error(this, this.title, res);
          return;
        }
        this.items = res.data;
      });
    },   
    handleChangePeriod(value) {
      this.period = value;
    },
    handleClickSearch() {
      if (!this.period.valid) { return; }
      this.loadData();
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },  
    handleResponse(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
    },
  }
};
</script>
